/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React from "react";

import { hasSelectedMicrodoseBiomarkerPlan } from "src/utils/userSegment/features";
import { isUS } from "src/utils/userSegment";
import { Text } from "src/components/core/Text";
import { PaymentEnrollmentFormState } from "src/utils/redux/slices/paymentEnrollmentForm";
import { handleTermAgreementClick } from "./agreementHandlers";

export interface AgreementConfig {
  key: keyof PaymentEnrollmentFormState["enrollmentInfo"];
  label: string | React.ReactNode;
  required: boolean;
  condition: () => boolean;
  dataCy?: string;
  trackingName?: string;
  onClickEffect?: (
    checked: boolean,
    enrollmentInfo: PaymentEnrollmentFormState["enrollmentInfo"]
  ) => void;
}

export const AGREEMENT_CONFIGS: AgreementConfig[] = [
  {
    key: "termAgreement",
    label: "",
    required: true,
    condition: () => isUS(),
    dataCy: "terms-agreement",
    trackingName: "CheckoutTermsAndConditions",
    onClickEffect: handleTermAgreementClick,
  },
  {
    key: "atHomeLabsConsent",
    label: (
      <Text
        i18nKey="payment:terms:atHomeLabsConsent"
        components={{
          ConsentLink: (
            <a
              href="/static/Ash-Patient-Consent.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-cy="at-home-labs-consent-link"
            />
          ),
        }}
      />
    ),
    required: true,
    condition: () => hasSelectedMicrodoseBiomarkerPlan(),
    dataCy: "at-home-labs-consent",
    trackingName: "AtHomeLabsConsent",
  },
];
